// * YOUTUBE SHORTS PLAYER 2.0 //

import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  slider: {
    transition: 'transform 350ms ease-in-out',
    '& > div': {
      color: theme.custom.whiteColor,
      height: '98vh',
      width: '100vw',
      margin: 'auto 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  videoPlayer: {
    border: '1px solid rgba(255, 255, 255, 0.2)',
    height: '100% !important',
    width: '380px',
    borderRadius: '12px',
  },
  playerOverlay: {
    position: 'absolute',
    top: 0,
    width: '380px',
    height: '100%',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'block',
    '-webkit-tap-highlight-color': 'transparent',
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
  icons: {
    width: '180px',
    height: 'fit-content',
    position: 'absolute',
    bottom: '1.5vh',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 4),
  },
  icon: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    padding: theme.spacing(2),
    margin: theme.spacing(2, 1),
    display: 'grid',
    placeContent: 'center',
    opacity: 0.2,
    transition: '200ms ease-in-out',
    ':hover': {
      opacity: 0.8,
    },
  },
  mobileRoot: {
    display: 'none',
    position: 'relative',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  mobilePlayerOverlay: {
    position: 'absolute',
    top: 0,
    width: '380px',
    height: '100%',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
}))

export default useStyles
